<template>
    <div class="image_editor">
        <v-switch v-model="newData.modeCarousel" label="Activer le mode carousel" />
        <div v-if="newData.modeCarousel">
            <file-pond ref="pond" name="test" class-name="my-pond" label-idle="Drop files here..."
                       allow-multiple="true" accepted-file-types="image/png, image/jpeg, image/jpg"
                       :server="serverConfig" :files="imageFilePondFiles" @init="handleFilePondInit(carouselImages, $cdnPath)" />
        </div>
        <div v-else>
            <v-layout row wrap>
                <v-flex xs8 class="custom_flex_image_data">
                    <v-file-input v-model="imageFiles" show-size :accept="imageTypes"
                                  class="image_file_upload" label="Ajoutez de fichier(s) image(s)..."
                                  :rules="imageRules" @change="onChangeImage"
                                  @drop="dropEvent($event, onChangeImage, ['image/png', 'image/jpeg', 'image/jpg'])"
                                  @dragleave="dragLeaveEvent" @dragover="dragOverEvent" />
                    <v-switch v-model="newData.imageWidth100" label="Mode 100% largeur" />
                    <v-switch v-model="newData.imageClickable" label="Activer la redirection" />
                    <v-text-field v-if="newData.imageClickable" v-model="newData.imageClickableText" filled
                                  maxlength="255" counter="255" label="Saisie de l'url de redirection..." />
                    <v-switch v-model="newData.imageLegend" label="Activer la legende" />
                    <v-text-field v-if="newData.imageLegend" v-model="newData.imageLegendText" filled maxlength="255"
                                  counter="255" label="Saisie du texte..." />
                </v-flex>
                <v-flex xs4>
                    <h3 class="center_text_preview">
                        Image Preview
                    </h3>
                    <v-img v-if="!newData.modeCarousel && newData.imagesPath[0]"
                           :src="$cdnPath + newData.imagesPath[0]" aspect-ratio="1"
                           class="grey lighten-2 center_image_preview"
                           max-height="380">
                        <template v-slot:placeholder>
                            <v-layout fill-height align-center justify-center ma-0>
                                <v-progress-circular indeterminate color="grey lighten-5" />
                            </v-layout>
                        </template>
                    </v-img>
                </v-flex>
            </v-layout>
        </div>
    </div>
</template>

<script>
    import { fileMixinImage } from '../../../global/FileMixinImage';
    import { fileMixinFilePond } from '../../../global/FileMixinFilePond';

    import vueFilePond from 'vue-filepond';
    import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
    import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
    import 'filepond/dist/filepond.min.css';
    import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';

    export default {
        name: 'ImageEditor',
        components: {
            FilePond: vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview)
        },
        mixins: [fileMixinImage, fileMixinFilePond],
        props: {
            value: {
                type: Object,
                default: () => {
                }
            }
        },
        data: () => ({
            newData: {},
            defaultData: {
                modeCarousel: false,
                imageClickable: false,
                imageLegend: false,
                imageWidth100: false,
                imagesPath: [],
                imagesName: [],
                imageClickableText: '',
                imageLegendText: ''
            }
        }),
        computed: {
            carouselImages: function () {
                let result = [];
                for (let i = 0; i < this.newData.imagesPath.length; i++) {
                    result.push({ path: this.newData.imagesPath[i], name: this.newData.imagesName[i] });
                }
                return result;
            }
        },
        watch: {
            newData: {
                handler (newValue) {
                    this.$emit('input', newValue);
                },
                deep: true,
                immediate: true
            },
            'newData.modeCarousel': function (newValue) {
                if (this.value.modeCarousel !== newValue) {
                    this.newData = { ...this.defaultData };
                    this.newData.modeCarousel = newValue;
                    this.imageFiles = [];
                }
            },
            'newData.imageClickableText': function (newValue) {
                this.newData.imageClickableText = !/^https?:\/\//i.test(newValue) ? 'http://' + newValue : newValue;
            },
            imageData: function (newValue) {
                if (newValue) {
                    this.newData.imagesPath = newValue.path !== '' ? [newValue.path] : [];
                    this.newData.imagesName = newValue.name !== '' ? [newValue.name] : [];
                }
            },
            imageFilePondFiles: function (newValue) {
                if (newValue) {
                    this.newData.imagesPath = newValue.map((item) => item.source.path);
                    this.newData.imagesName = newValue.map((item) => item.source.name);
                    this.$emit('validate', this.filePondValid);
                }
            }
        },
        created () {
            if (JSON.stringify(this.value) === JSON.stringify({})) {
                this.newData = { ...this.defaultData };
            } else {
                this.newData = { ...this.value };
            }
            if (!this.value.modeCarousel && this.newData.imagesPath[0]) {
                let file = { path: this.newData.imagesPath[0], name: this.newData.imagesName[0] };
                this.initImageFiles(file, this.$cdnPath, true);
            }
        },
        methods: {
            dropEvent: function (e, callback, typeAccept) {
                e.preventDefault();
                if (typeAccept.indexOf(e.dataTransfer.files[0].type) !== -1) {
                    callback(e.dataTransfer.files[0]);
                } else {
                    this.$toasted.error('Type of file don\'t accepted');
                }
            },
            dragLeaveEvent: function (e) {
                e.preventDefault();
            },
            dragOverEvent: function (e) {
                e.preventDefault();
            }
        }
    };
</script>

<style scoped>
    .custom_flex_image_data {
        padding-right: 20px !important;
    }

    .center_text_preview {
        text-align: center;
    }

    .center_image_preview {
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
</style>
